import {
  LayoutDashboard,
  BookOpen,
  Rocket,
  TrendingUp,
  Users,
  UsersRound,
  Wallet,
  ShieldAlert,
  Link2,
  UserCog,
  ScrollText,
  Trash2,
  SlidersHorizontal,
} from "lucide-react";

export const NAV_ITEMS = [
  {
    to: "/",
    label: "Command Centre",
    icon: LayoutDashboard,
    testid: "nav-command-centre",
    description: "The single source of truth across the Edju Cat operation.",
  },
  {
    to: "/office",
    label: "Office & Team",
    icon: UsersRound,
    testid: "nav-office-team",
    description: "Where the founders plan, meet, work and think together.",
  },
  {
    to: "/product",
    label: "Product & Content",
    icon: BookOpen,
    testid: "nav-product-content",
    description: "Track learning content, features and the product roadmap.",
  },
  {
    to: "/launch",
    label: "Launch Tracker",
    icon: Rocket,
    testid: "nav-launch-tracker",
    description: "Monitor launch readiness across every workstream.",
  },
  {
    to: "/marketing",
    label: "Marketing & Growth",
    icon: TrendingUp,
    testid: "nav-marketing-growth",
    description: "Campaigns, channels and growth experiments.",
  },
  {
    to: "/investors",
    label: "Investor Pipeline",
    icon: Users,
    testid: "nav-investor-pipeline",
    description: "Manage conversations and momentum with investors.",
    requires: "investor_access",
  },
  {
    to: "/finance",
    label: "Finance & Runway",
    icon: Wallet,
    testid: "nav-finance-runway",
    description: "Keep sight of spend, burn and remaining runway.",
    requires: "finance_access",
  },
  {
    to: "/decisions",
    label: "Decisions & Risks",
    icon: ShieldAlert,
    testid: "nav-decisions-risks",
    description: "Log key decisions, blockers and open risks.",
    requires: "decisions_access",
  },
  {
    to: "/links",
    label: "Links",
    icon: Link2,
    testid: "nav-links",
    description: "Handy websites and tools for the Edju Cat team.",
  },
  {
    to: "/admin/users",
    label: "User Management",
    icon: UserCog,
    testid: "nav-admin-users",
    description: "Manage team access, roles and permissions.",
    adminOnly: true,
  },
  {
    to: "/admin/audit",
    label: "Audit Log",
    icon: ScrollText,
    testid: "nav-admin-audit",
    description: "Review security events and record changes across the hub.",
    adminOnly: true,
  },
  {
    to: "/admin/recycle-bin",
    label: "Recycle Bin",
    icon: Trash2,
    testid: "nav-admin-recycle-bin",
    description: "Restore or permanently remove deleted records.",
    adminOnly: true,
  },
  {
    to: "/admin/settings",
    label: "System Settings",
    icon: SlidersHorizontal,
    testid: "nav-admin-settings",
    description: "System health, users summary, backups and restore.",
    adminOnly: true,
  },
];
